module.exports = __webpack_public_path__ + "static/media/sdg_icon_6.7131625d.png";